import React from "react";
import "./AddBlockButton.css";

const AddBlockButton = ({ onClick, showOptions, onBlockSelect }) => {
    const blockTypes = [
        { type: 'vendor_banner', name: 'Hero Block', icon: 'mdi-view-carousel' },
        { type: 'vendor_text_and_image', name: 'Text and Image Block', icon: 'mdi-file-image-outline' },
        { type: 'vendor_image_and_text', name: 'Image and Text Block', icon: 'mdi-image-text' },
        { type: 'textAndVideo', name: 'Text and Video Block', icon: 'mdi-video' },
        { type: 'videoAndText', name: 'Video and Text Block', icon: 'mdi-video' },
        { type: 'process', name: 'Process Block', icon: 'mdi-cogs' },
        { type: 'catalog', name: 'Products Block', icon: 'mdi-star' }
    ];

    return (
        <div className="add-block-container">
            <button 
                className="add-block-btn"
                onClick={onClick}
            >
                <span className="mdi mdi-plus-circle"></span>
                Add Block
            </button>
            
            {showOptions && (
                <div className="block-options">
                    <div className="block-options-header">
                        <h4>Choose Block Type</h4>
                    </div>
                    <div className="block-options-list">
                        {blockTypes.map((block) => (
                            <div 
                                key={block.type}
                                className="block-option"
                                onClick={() => onBlockSelect(block.type)}
                            >
                                <span className={`mdi ${block.icon}`}></span>
                                <span>{block.name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddBlockButton;
